export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-4">随时随地上网导航</h2>
            <p className="text-background-50/90 text-sm md:text-base leading-relaxed mb-6 max-w-[480px] mx-auto lg:mx-0">
              51网址导航已适配移动端，在手机浏览器中打开即可获得与桌面端一致的上网导航体验。
              无需下载安装，打开即用，网址导航123快捷入口触手可及。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="whitespace-nowrap inline-flex items-center gap-2 bg-background-50 text-primary-600 font-semibold px-6 py-3 rounded-xl cursor-pointer text-sm">
                <i className="ri-smartphone-line"></i>
                手机浏览器打开
              </div>
              <div className="whitespace-nowrap inline-flex items-center gap-2 bg-background-50/20 text-background-50 font-medium px-6 py-3 rounded-xl border border-background-50/30 cursor-pointer text-sm">
                <i className="ri-qr-code-line"></i>
                扫码体验
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative">
              <div className="w-[200px] md:w-[240px] aspect-[9/16] bg-background-50 rounded-2xl overflow-hidden border-4 border-background-50/20">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20mobile%20phone%20screen%20showing%20a%20modern%20Chinese%20website%20navigation%20homepage%20with%20category%20icons%20and%20news%20cards%2C%20warm%20cream%20background%2C%20clean%20minimalist%20UI%20design%2C%20soft%20orange%20accent%20colors%2C%20friendly%20and%20inviting%20interface%2C%20editorial%20app%20screenshot%20style&width=600&height=1067&seq=app-mobile-01&orientation=portrait"
                  alt="51网址导航移动端展示"
                  className="w-full h-full object-cover"
                  width="600"
                  height="1067"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}